/**
 * When /integrated treats a subscription as over (PIT-546 g): the local row says expired, or Zenpost
 * no longer counts the customer as paying, the paid access ended there, and the row has no paid time
 * left either. A row with paid time left against Zenpost's "not paying" is a reactivation push that
 * has not landed yet (hydration keeps it on purpose), not an ended subscription. A `canceled` row
 * has its cancellation open: it ends by sync:scheduled-changes, and "Cancelar" is not for it. The
 * page and the cancel route read it the same way, so the screen and what "Cancelar" does never
 * disagree.
 */
export function subscriptionEnded(
  args: {
    status: string | null | undefined;
    currentPeriodEnd: string | Date | null | undefined;
    isPayingCustomer: boolean | null | undefined;
    datePaymentsEnded: string | null | undefined;
  },
  now = Date.now(),
): boolean {
  if (args.status === "expired") return true;
  if (args.status === "canceled") return false;
  if (args.isPayingCustomer || !args.datePaymentsEnded) return false;
  const paidThrough = args.currentPeriodEnd ? new Date(args.currentPeriodEnd).getTime() : NaN;
  if (Number.isFinite(paidThrough) && paidThrough > now) return false;
  const ended = new Date(args.datePaymentsEnded).getTime();
  return Number.isFinite(ended) && ended < now;
}
